<template>
  <v-row no-gutters>
    <v-col
      md="8"
      offset-md="2">
      <v-container class="page page--form">
        <discount-form
          :source="$route.params.source"
          :account-pk="$route.query.accountPk" />
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
  //   import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DiscountForm from '../components/DiscountForm'

  export default {
    name: 'NewDiscount',
    components: { DiscountForm },
    data () {
      return {}
    }
  }
</script>

<style scoped>

</style>
